/**
 * Steps of a multi-step auth flow (e.g. invitation-based password creation).
 *
 * Kept as named constants so step names are never inline string literals in
 * credential-related modules (SAST tools misread them as hard-coded
 * passwords).
 */
export const FLOW_STEP = {
  loading: 'loading',
  error: 'error',
  form: 'form',
  success: 'success',
} as const;
